// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1qCln","name":"ConsentHeader_name__B-ADW","birthday":"ConsentHeader_birthday__zL7bA","skeleton":"ConsentHeader_skeleton__2Bjnw"};